import { render, staticRenderFns } from "./BlockFlag.vue?vue&type=template&id=094aed90&scoped=true"
import script from "./BlockFlag.vue?vue&type=script&lang=js"
export * from "./BlockFlag.vue?vue&type=script&lang=js"
import style0 from "./BlockFlag.vue?vue&type=style&index=0&id=094aed90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094aed90",
  null
  
)

export default component.exports